import { Controller } from "@hotwired/stimulus"

// Reveals a hover tooltip for a truncated label — but only when the label text actually overflows
// (an ellipsis is showing). The tooltip markup uses the same CSS group-hover styling as the
// Argyle/Stripe "what is this?" tooltip; this controller just toggles the `group` marker (and a
// help cursor) on the root so the tooltip stays inert for labels that fit. Re-measures on resize.
export default class extends Controller {
  static targets = ["label"]

  connect() {
    this.update = this.update.bind(this)
    this.update()
    window.addEventListener("resize", this.update)
  }

  disconnect() {
    window.removeEventListener("resize", this.update)
  }

  update() {
    if (!this.hasLabelTarget) return
    const el = this.labelTarget
    // +1 guards against sub-pixel rounding that would otherwise flag non-truncated labels.
    const truncated = el.scrollWidth > el.clientWidth + 1
    this.element.classList.toggle("group", truncated)
    this.element.classList.toggle("cursor-help", truncated)
  }
}
